import icon_lock from '../Pages/Player/images/lock.png'
import icon_rec from '../Pages/Player/images/original.png'
import icon_premium from '../Pages/Player/images/premium.png'
import Image from '../Util/img';
import { useRouter } from "../../hooks/router";

export default function CardChannels({
    rowLength,
    cardIndex,
    card,
    setShowPremium,
    isGuest
}) {
    const router = useRouter()

    return (
        <>

            <div className="main_card_channel" onClick={() => {

                if (card.canWatch) {

                    router.push(`/player?type=live&id=${card.id}`)
                    
                } else {

                    setShowPremium({
                        show: true,
                        id: card.id,
                        type: 'live'
                    })
                    
                }

            }}>

                <Image className={'image_channel_card'} src={card.image} height='107px' placeholder={localStorage.getItem('logo')} />

                {card.is_protected ?
                    <img className={'icon_lock_card'} src={icon_lock} alt="" />
                    : null}
                {card.archived_channel ?
                    <img className={'icon_rec_card'} src={icon_rec} alt="" />
                    : null}
                {!card.canWatch ?
                    <img className={'icon_premium_card'} src={icon_premium} alt="" />
                    : null}

            </div>
        </>

    )
}